import React from 'react';
import Trades from '../../components/Trades/index';
import Features from '../../components/Features/index';

export default function Testing() {
        return (
                <div>
                        <Trades />
                </div>
        );
}
